//admin
import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { MailingListUpdatePayload, RequestPayload } from './types';
import { UserInfo } from './models';
//const ENDPOINT = 'admin/'

export interface HistoryItem {
  id: number,
  user: UserInfo,
  url: string,
  url_rule: string,
  create_dt: string,
  json_hash: string,
  source: string | null,
  json: any,
  params: any
}

const admin = (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  getHistory: (payload: RequestPayload) =>
    instance.post<ApiResponse<Paginated<'data', HistoryItem>>>('/service/log/activity_user/list/', payload, config),
  getMailingLists: () =>
    instance.get('/service/mailing_lists/get/', config),
  updateMailingList: (payload: MailingListUpdatePayload) =>
    instance.put('/service/mailing_lists/update/', payload, config),
});
export default admin;
